import { useState } from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Filter from '../Filter';
import Slider from 'components/Theme/Elements/Slider';

import PPPIcon from 'assets/discovery/PPP-icon.png';

function PPPFilter({ value = null, setFilters }) {
  const classes = useStyles();
  const [engRate, setEngRate] = useState(value);

  const handleFilter = (event, newValue) => {
    setFilters({
      ppp: newValue,
    });
  };

  const handleChange = (event, newValue) => {
    setEngRate(newValue);
  };

  return (
    <Grid container className={classes.root}>
      <Grid item md={12}>
        <Filter label={'Paid Post Performance'} labelIconSrc={PPPIcon}>
          <Grid container className={classes.filterContainer}>
            <Slider
              value={engRate}
              onChangeCommitted={handleFilter}
              onChange={handleChange}
              valueLabelDisplay="auto"
              max={200}
              min={0}
            />
          </Grid>
        </Filter>
      </Grid>
    </Grid>
  );
}

const useStyles = makeStyles(() => ({
  root: {},
}));

export default PPPFilter;
